import React, { Component } from "react";
import { CallAPI, HandleTextChange, GetCookieFunction } from '../../utils/util';
import Alert from 'react-bootstrap/Alert';

class CenterSettings extends Component {
    constructor(props) {
        super(props);
        this.centerId = GetCookieFunction("Center").id;
        this.state = {
            name: "", email: "", phone: "", address: "", link: "", prefix: "",
            totalMachines: 0, machinesDown: 0, availableMachines: 0,
            modalVariant: "", modalMessage: "", loading: true
        };
        this.handleTextChange = HandleTextChange.bind(this);
    }

    componentDidMount() {
        CallAPI({}, `admin/center?centerId=${this.centerId}`, 'GET', (res) => {
            if (res.success) {
                this.setState({ ...res.data, loading: false });
            }
        }, () => {
            this.setState({ loading: false, modalVariant: "danger", modalMessage: "Failed to load center settings" });
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const payload = {
            centerId: this.centerId,
            name: this.state.name,
            email: this.state.email,
            phone: this.state.phone,
            address: this.state.address,
            link: this.state.link,
            prefix: this.state.prefix,
            totalMachines: parseInt(this.state.totalMachines, 10),
            machinesDown: parseInt(this.state.machinesDown, 10)
        };

        CallAPI(payload, 'admin/center', 'PUT', (res) => {
            if (res.success) {
                this.setState({
                    modalVariant: "success",
                    modalMessage: "Center settings saved.",
                    availableMachines: payload.totalMachines - payload.machinesDown
                });
            } else {
                this.setState({ modalVariant: "danger", modalMessage: res.message || "Failed to save" });
            }
        }, () => {
            this.setState({ modalVariant: "danger", modalMessage: "Failed to save center settings" });
        });
    }

    render() {
        if (this.state.loading) {
            return <div className="ci-page"><div className="ci-header"><h2>Loading...</h2></div></div>;
        }

        return (
            <div className="ci-page">
                <div className="ci-header">
                    <h2>Center Settings</h2>
                    <p>Manage your center's information and machine capacity</p>
                </div>

                {this.state.modalVariant && (
                    <Alert variant={this.state.modalVariant} className="ci-alert">{this.state.modalMessage}</Alert>
                )}

                <form onSubmit={this.handleSubmit}>
                    <div className="ci-section-title">Center Information</div>
                    <div className="ci-card">
                        <div className="ci-grid">
                            <div className="ci-field">
                                <label htmlFor="name">Center Name</label>
                                <input type="text" id="name" name="name" required maxLength="32"
                                    value={this.state.name} onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="prefix">Prefix (for Patient IDs)</label>
                                <input type="text" id="prefix" name="prefix" maxLength="10"
                                    value={this.state.prefix || ""} onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="email">Email</label>
                                <input type="email" id="email" name="email" required maxLength="100"
                                    value={this.state.email} onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="phone">Phone</label>
                                <input type="tel" id="phone" name="phone" required maxLength="64"
                                    value={this.state.phone} onChange={(e) => this.handleTextChange(e)} />
                            </div>
                        </div>
                        <div className="ci-field" style={{marginTop: '14px'}}>
                            <label htmlFor="address">Address</label>
                            <input type="text" id="address" name="address" required maxLength="500"
                                value={this.state.address} onChange={(e) => this.handleTextChange(e)} />
                        </div>
                        <div className="ci-field" style={{marginTop: '14px'}}>
                            <label htmlFor="link">Website Link</label>
                            <input type="text" id="link" name="link" maxLength="150"
                                value={this.state.link} onChange={(e) => this.handleTextChange(e)} />
                        </div>
                    </div>

                    <div className="ci-section-title">Machine Capacity</div>
                    <div className="ci-card">
                        <div className="ci-grid">
                            <div className="ci-field">
                                <label htmlFor="totalMachines">Total Machines</label>
                                <input type="number" id="totalMachines" name="totalMachines" min="0"
                                    value={this.state.totalMachines} onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="machinesDown">Machines Down</label>
                                <input type="number" id="machinesDown" name="machinesDown" min="0"
                                    value={this.state.machinesDown} onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label>Available Machines</label>
                                <div style={{padding: '9px 12px', background: 'var(--bg)', borderRadius: 'var(--radius-sm)', fontWeight: 600, fontSize: '18px', color: 'var(--primary)'}}>
                                    {(parseInt(this.state.totalMachines, 10) || 0) - (parseInt(this.state.machinesDown, 10) || 0)}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="ci-submit-row">
                        <button type="submit" className="logSubmit ci-submit-btn">Save Settings</button>
                    </div>
                </form>
            </div>
        );
    }
}

export default CenterSettings;
